"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableColumnPersonProperty = exports.resultsTableColumnPersonPropertyDefinition = void 0;
exports.resultsTableColumnPersonPropertyDefinition = {
    view: { label: 'Results Table Column Person' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'orderedProperties',
            argument: [
                'results-table-column-name',
                'results-table-column-pinned',
                'results-table-column-title',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'results-table-column-person',
};
const isResultsTableColumnPersonProperty = (prop) => {
    return prop.name === exports.resultsTableColumnPersonPropertyDefinition.name;
};
exports.isResultsTableColumnPersonProperty = isResultsTableColumnPersonProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1jb2x1bW4tcGVyc29uLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcmVzdWx0cy10YWJsZS1jb2x1bW4tcGVyc29uLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMENBQTBDLEdBQUc7SUFDeEQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLDZCQUE2QixFQUFFO0lBQzlDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLG1CQUFtQjtZQUN6QixRQUFRLEVBQUU7Z0JBQ1IsMkJBQTJCO2dCQUMzQiw2QkFBNkI7Z0JBQzdCLDRCQUE0QjthQUM3QjtTQUNGO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsbUJBQW1CO0lBQ3pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLDZCQUE2QjtDQUNKLENBQUE7QUFJMUIsTUFBTSxrQ0FBa0MsR0FBRyxDQUFDLElBQWtCLEVBQTRDLEVBQUU7SUFDakgsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGtEQUEwQyxDQUFDLElBQUksQ0FBQTtBQUN0RSxDQUFDLENBQUE7QUFGWSxRQUFBLGtDQUFrQyxzQ0FFOUMifQ==